// import React, { useEffect, useState } from "react";
// import axios from "axios";

// const DepartmentForm = () => {
//   const [departmentData, setDepartmentData] = useState(null);

//   useEffect(() => {
//     // Fetch department data from the backend
//     const fetchDepartmentData = async () => {
//       try {
//         const response = await axios.get("http://localhost:5000/api/getDepartment");
//         setDepartmentData(response.data);
//       } catch (err) {
//         console.error("Error fetching department data:", err);
//       }
//     };

//     fetchDepartmentData();
//   }, []);

//   if (!departmentData) {
//     return <div>Loading...</div>;
//   }

//   return (
//     <div>
//       <h1>Department Details</h1>
//       <div>
//         <h2>Vision</h2>
//         <p>{departmentData.vision}</p>
//       </div>
//       <div>
//         <h2>Mission</h2>
//         <p>{departmentData.mission}</p>
//       </div>
//       <div>
//         <h2>About</h2>
//         <p>{departmentData.about}</p>
//       </div>
//       {departmentData.departmentPhoto && (
//         <div>
//           <h2>Department Photo</h2>
//           <img
//             src={`http://localhost:5000/${departmentData.departmentPhoto}`}
//             alt="Department"
//             style={{ maxWidth: "300px", borderRadius: "10px" }}
//           />
//         </div>
//       )}
//       <div>
//         <h2>Head of Department (HOD)</h2>
//         <p><strong>Name:</strong> {departmentData.hodDetails.name}</p>
//         <p><strong>Talk:</strong> {departmentData.hodDetails.talk}</p>
//         {departmentData.hodDetails.photo && (
//           <img
//             src={`http://localhost:5000/${departmentData.hodDetails.photo}`}
//             alt="HOD"
//             style={{ maxWidth: "200px", borderRadius: "50%" }}
//           />
//         )}
//       </div>
//       <div>
//         <h2>Faculty Members</h2>
//         {departmentData.facultyDetails.map((faculty, index) => (
//           <div key={index} style={{ marginBottom: "20px" }}>
//             <p><strong>Name:</strong> {faculty.name}</p>
//             <p><strong>Designation:</strong> {faculty.designation}</p>
//             <p><strong>Qualification:</strong> {faculty.qualification}</p>
//             <p><strong>Interests:</strong> {faculty.interests}</p>
//             {faculty.photo && (
//               <img
//                 src={`http://localhost:5000/${faculty.photo}`}
//                 alt={faculty.name}
//                 style={{ maxWidth: "150px", borderRadius: "10px" }}
//               />
//             )}
//           </div>
//         ))}
//       </div>
//       <div>
//         <h2>Non-Faculty Members</h2>
//         {departmentData.NonFaculty.map((nonFaculty, index) => (
//           <div key={index} style={{ marginBottom: "20px" }}>
//             <p><strong>Name:</strong> {nonFaculty.name}</p>
//             <p><strong>Designation:</strong> {nonFaculty.designation}</p>
//             <p><strong>Qualification:</strong> {nonFaculty.qualification}</p>
//             <p><strong>Interests:</strong> {nonFaculty.interests}</p>
//             {nonFaculty.photo && (
//               <img
//                 src={`http://localhost:5000/${nonFaculty.photo}`}
//                 alt={nonFaculty.name}
//                 style={{ maxWidth: "150px", borderRadius: "10px" }}
//               />
//             )}
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default DepartmentForm;
// Install dependencies: npm install axios react-bootstrap bootstrap
import React, { useState } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";

function DepartmentForm() {
  const [departmentData, setDepartmentData] = useState({
    departmentName: "",  // Add departmentName to the state
    vision: "",
    mission: "",
    about: "",
    hodDetails: { name: "", talk: "" },
    facultyDetails: [{ name: "", designation: "", qualification: "", interests: "" }],
    NonFaculty: [{ name: "" }],
  });

  const [departmentPhoto, setDepartmentPhoto] = useState(null);
  const [hodPhoto, setHodPhoto] = useState(null);
  const [facultyPhotos, setFacultyPhotos] = useState([]);
  const [nonFacultyPhotos, setNonFacultyPhotos] = useState([]);
  const [message, setMessage] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDepartmentData((prev) => ({ ...prev, [name]: value }));
  };

  const handleNestedInputChange = (e, parent, index, field) => {
    const value = e.target.value;
  
    setDepartmentData((prev) => {
      if (Array.isArray(prev[parent])) {
        // Handle the case for arrays (like facultyDetails and NonFaculty)
        const updated = [...prev[parent]];
        updated[index][field] = value;
        return { ...prev, [parent]: updated };
      } else if (typeof prev[parent] === 'object') {
        // Handle the case for objects (like hodDetails)
        return {
          ...prev,
          [parent]: {
            ...prev[parent],
            [field]: value,
          },
        };
      } else {
        return prev;
      }
    });
  };
  

  const addFaculty = () => {
    setDepartmentData((prev) => ({
      ...prev,
      facultyDetails: [...prev.facultyDetails, { name: "", designation: "", qualification: "", interests: "" }],
    }));
    setFacultyPhotos((prev) => [...prev, null]);
  };

  const addNonFaculty = () => {
    setDepartmentData((prev) => ({
      ...prev,
      NonFaculty: [...prev.NonFaculty, { name: "" }],
    }));
    setNonFacultyPhotos((prev) => [...prev, null]);
  };

  const handleFileChange = (e, setFiles, index = null) => {
    const file = e.target.files[0];
    if (index === null) {
      setFiles(file);
    } else {
      setFiles((prev) => {
        const updated = [...prev];
        updated[index] = file;
        return updated;
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("data", JSON.stringify(departmentData)); // Send department data including departmentName
    if (departmentPhoto) formData.append("departmentPhoto", departmentPhoto);
    if (hodPhoto) formData.append("hodPhoto", hodPhoto);
    facultyPhotos.forEach((file) => formData.append("facultyPhotos", file));
    nonFacultyPhotos.forEach((file) => formData.append("nonFacultyPhotos", file));

    try {
      const response = await axios.post("http://localhost:5000/api/saveDepartment", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setMessage(response.data.message);
    } catch (err) {
      console.error(err);
      setMessage("Failed to save department data.");
    }
  };

  return (
    <div className="container mt-5">
      <h2>Department Form</h2>
      {message && <div className="alert alert-info">{message}</div>}
      <form onSubmit={handleSubmit}>
        {/* Department Name */}
        <div className="mb-3">
          <label>Department Name</label>
          <input
            type="text"
            className="form-control"
            name="departmentName"
            value={departmentData.departmentName}
            onChange={handleInputChange}
          />
        </div>

        {/* Vision */}
        <div className="mb-3">
          <label>Vision</label>
          <input
            type="text"
            className="form-control"
            name="vision"
            value={departmentData.vision}
            onChange={handleInputChange}
          />
        </div>

        {/* Mission */}
        <div className="mb-3">
          <label>Mission</label>
          <input
            type="text"
            className="form-control"
            name="mission"
            value={departmentData.mission}
            onChange={handleInputChange}
          />
        </div>

        {/* About */}
        <div className="mb-3">
          <label>About</label>
          <textarea
            className="form-control"
            name="about"
            value={departmentData.about}
            onChange={handleInputChange}
          />
        </div>

        {/* Department Photo */}
        <div className="mb-3">
          <label>Department Photo</label>
          <input type="file" className="form-control" onChange={(e) => handleFileChange(e, setDepartmentPhoto)} />
        </div>

        {/* Head of Department */}
        <h4>Head of Department</h4>
        <div className="mb-3">
          <label>Name</label>
          <input
            type="text"
            className="form-control"
            value={departmentData.hodDetails.name}
            onChange={(e) => handleNestedInputChange(e, "hodDetails", null, "name")}
          />
        </div>
        <div className="mb-3">
          <label>Talk</label>
          <textarea
            className="form-control"
            value={departmentData.hodDetails.talk}
            onChange={(e) => handleNestedInputChange(e, "hodDetails", null, "talk")}
          />
        </div>
        <div className="mb-3">
          <label>Photo</label>
          <input type="file" className="form-control" onChange={(e) => handleFileChange(e, setHodPhoto)} />
        </div>

        {/* Faculty Details */}
        <h4>Faculty Details</h4>
        {departmentData.facultyDetails.map((faculty, index) => (
          <div key={index} className="mb-3">
            <input
              type="text"
              placeholder="Name"
              className="form-control"
              value={faculty.name}
              onChange={(e) => handleNestedInputChange(e, "facultyDetails", index, "name")}
            />
            <input
              type="text"
              placeholder="Designation"
              className="form-control mt-2"
              value={faculty.designation}
              onChange={(e) => handleNestedInputChange(e, "facultyDetails", index, "designation")}
            />
            <input
              type="text"
              placeholder="Qualification"
              className="form-control mt-2"
              value={faculty.qualification}
              onChange={(e) => handleNestedInputChange(e, "facultyDetails", index, "qualification")}
            />
            <input
              type="text"
              placeholder="Interests"
              className="form-control mt-2"
              value={faculty.interests}
              onChange={(e) => handleNestedInputChange(e, "facultyDetails", index, "interests")}
            />
            <input
              type="file"
              className="form-control mt-2"
              onChange={(e) => handleFileChange(e, setFacultyPhotos, index)}
            />
          </div>
        ))}
        <button type="button" className="btn btn-secondary" onClick={addFaculty}>
          Add Faculty
        </button>

        {/* Non-Faculty Details */}
        <h4>Non-Faculty Details</h4>
        {departmentData.NonFaculty.map((nonFaculty, index) => (
          <div key={index} className="mb-3">
            <input
              type="text"
              placeholder="Name"
              className="form-control"
              value={nonFaculty.name}
              onChange={(e) => handleNestedInputChange(e, "NonFaculty", index, "name")}
            />
            <input
              type="file"
              className="form-control mt-2"
              onChange={(e) => handleFileChange(e, setNonFacultyPhotos, index)}
            />
          </div>
        ))}
        <button type="button" className="btn btn-secondary" onClick={addNonFaculty}>
          Add Non-Faculty
        </button>

        {/* Submit Button */}
        <button type="submit" className="btn btn-primary mt-3">
          Submit
        </button>
      </form>
    </div>
  );
}

export default DepartmentForm;
